import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=33bfb28f&scoped=true&"
import script from "./Production.vue?vue&type=script&lang=js&"
export * from "./Production.vue?vue&type=script&lang=js&"
import style0 from "./Production.vue?vue&type=style&index=0&id=33bfb28f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfb28f",
  null
  
)

export default component.exports